/*
 * Quantity pickers inside product cards (.product-item).
 *
 * Product cards are rendered by snippets/product-item.liquid across the
 * collection, featured-collection, recommendation and recently-viewed
 * sections. Unlike the product page, none of those sections boot a picker of
 * their own, so without this the +/- controls are inert markup.
 *
 * QuantityPicker is exposed on window by theme.js, which is why this file must
 * stay ordered after it (both are `defer` in layout/theme.liquid).
 */
(function () {
  var CARD_SELECTOR = '.product-item';
  var PICKER_SELECTOR = '.quantity-selector.quantity-selector--product';
  var READY_ATTRIBUTE = 'data-quantity-picker-ready';

  function attachToCard(card) {
    var picker = card.querySelector(PICKER_SELECTOR);

    if (!picker || picker.hasAttribute(READY_ATTRIBUTE)) {
      return;
    }

    // theme.js has not run yet. Leave the picker unmarked so a later pass picks it up.
    if (typeof window.QuantityPicker !== 'function') {
      return;
    }

    picker.setAttribute(READY_ATTRIBUTE, '');
    card.quantityPicker = new window.QuantityPicker(picker);
  }

  function attachWithin(root) {
    if (!root || root.nodeType !== 1) {
      return;
    }

    // The node may be a card itself (AJAX filtering swaps cards in directly) or
    // a wrapper around several of them (a carousel, a re-rendered grid).
    if (root.matches(CARD_SELECTOR)) {
      attachToCard(root);
    }

    Array.prototype.forEach.call(root.querySelectorAll(CARD_SELECTOR), attachToCard);
  }

  function attachToDocument() {
    attachWithin(document.body);
  }

  function observeProductListChanges() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, attachWithin);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    attachToDocument();
    observeProductListChanges();

    // Safety net for the case where theme.js has not finished executing yet.
    if (typeof window.QuantityPicker !== 'function') {
      window.addEventListener('load', attachToDocument);
    }
  }

  // This script may be evaluated before or after the document has been parsed,
  // so never assume DOMContentLoaded is still to come.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
